import { getServerFirebaseApp, getSession } from '@/shared/lib/server'

import { NavigationBarUI } from './navigation-bar-ui'
import { SimpleNavigationBarUI } from './simple-navigation-bar-ui'

type Props = {
  wide?: boolean
  variant?: 'default' | 'simple'
  className?: string
}

export async function NavigationBar({
  wide = false,
  variant = 'default',
  className,
}: Props) {
  const session = await getSession()
  const isLoggedIn = !!session
  const isHost = session?.isHost

  let userId: number | undefined

  if (isLoggedIn) {
    const { currentUser } = await getServerFirebaseApp()

    userId = currentUser ? Number(currentUser.uid) : undefined
  }

  if (variant === 'simple') {
    return <SimpleNavigationBarUI />
  }

  return (
    <NavigationBarUI
      wide={wide}
      isLoggedIn={isLoggedIn}
      isHost={isHost}
      userId={userId}
      className={className}
    />
  )
}
